'use client';
import Breadcrumb from '@/components/@base/breadcrumb';
import { BreadcrumbList } from '@/components/@base/breadcrumb/type';
import Container from '@/components/@base/container';
import Props from '@/components/app/archive/components/info/search/type';
import { FILTER_KEYS } from '@/components/app/archive/helpers';

import localization, { pageLevelLocalization } from '@/constant/localization';
const { archive: archiveLocalization } = pageLevelLocalization;

export default function Info({ initialFilters = {} }: Props) {
  const currentBreadcrumb: BreadcrumbList = {
    label: archiveLocalization.searchResult,
    active: true,
  };
  if (FILTER_KEYS.FIND in initialFilters) {
    currentBreadcrumb.label = `${archiveLocalization.searchResult}: ${initialFilters[FILTER_KEYS.FIND]}`;
  }
  const customBreadcrumbList: BreadcrumbList[] = [
    { label: localization.home, url: '/', active: false },
    currentBreadcrumb,
  ];

  return (
    <Container className='gap-2 pb-2 pt-9 md:flex md:py-6'>
      <Container className='flex flex-col justify-center gap-1 px-4 md:flex-1 md:gap-3 md:p-0'>
        <Breadcrumb className='text-[#737373]' customBreadCrumbList={customBreadcrumbList} />
      </Container>
    </Container>
  );
}
